import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, commonActions, certboxActions } from '../../../../../store/actions'
import moment from 'moment'
import Alert from '../../../../../module/alert/Alert'
import { commons } from '../../../../../hook/common'
import PdfViewer from '../../../../../module/pdf/PdfViewer'

/*
   계약 form
 */
const CertboxForm21 = (props) => {
  const [state, setState] = useState({})
  const [commoncode, setCommoncode] = useState({})
  const [isShowPdf, setIsShowPdf] = useState(false) //삭제 버튼 표시 여부
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()

  const gnrlInfoCn = JSON.parse(props.data?.gnrlInfoCn)
  const signerList = JSON.parse(gnrlInfoCn.signerList)

  //  const signer = []
  //console.log('gnrlInfoCn = ', gnrlInfoCn);
  console.log('signerList = ', signerList)

  useEffect(() => {
    props.getCommonCode({ mainCd: ['CRT_FORM_TP', 'CRT_PERFORM_TP', 'CRT_SUBMIS_TP', 'CRT_DV'] })
  }, [])

  useEffect(() => {
    setCommoncode({
      ...commoncode,
      ...props.commoncode,
    })

    setState({
      ...state,
      docFormatNm: props.commoncode?.CRT_FORM_TP?.find((co) => co.cd === props.data?.docFormat)?.cdName,
      docTypeNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submisType)?.cdName,
      submissionNm: props.commoncode?.CRT_SUBMIS_TP?.find((co) => co.cd === props.data?.submission)?.cdName,
      crtNm: props.commoncode?.CRT_DV?.find((co) => co.cd === props.data?.crtCd)?.cdName,
    })
  }, [props.commoncode])

  //console.log('props.commoncode = ', props.commoncode);
  //console.log('props.commoncode.CRT_DV = ', props.commoncode['CRT_DV']);
  /*
    console.log('props = ', props);
    console.log('props.commoncode?.CRT_DV = ', props.commoncode?.CRT_DV?.cd);
    console.log('props.data = ', props.data);
    console.log('state = ', state);
    */
  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  // let onPdfDown = (crtCd, docid, brno, fileObj) => {
  //   let fileList = []
  //   if (fileObj) {
  //     fileList.push(fileObj)
  //   }
  //   if (!fileList || !fileList.length) {
  //     props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
  //     return
  //   }
  //   fileList.forEach((val, idx, arr) => {
  //     if (crtCd === '03' && fileList[idx].readYn === 'N') {
  //       const params = {
  //         docId: docid,
  //         fileId: fileList[idx].fileId,
  //         brno: brno,
  //       }
  //       props.getDownLoad(params)
  //     }
  //
  //     setTimeout(() => {
  //       let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
  //       let xhr = new XMLHttpRequest()
  //       xhr.responseType = 'blob'
  //       xhr.open('GET', url)
  //       xhr.send()
  //       xhr.onload = function () {
  //         if (xhr.status === 200) {
  //           // HTTP가 잘 동작되었다는 뜻.
  //           setShowResponse(window.URL.createObjectURL(xhr.response))
  //           setBlobResponse(xhr.response)
  //           setShowFileNm(val['originFileNm'])
  //           setIsShowPdf(true)
  //           setDocid(docid)
  //           setCrtCd(crtCd)
  //           setBrno(brno)
  //           setOldYn('N')
  //           setFileId(fileList[idx].fileId)
  //           setPrintYn(fileList[idx].printYn)
  //         } else {
  //           props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
  //           return
  //         }
  //       }
  //     }, 30)
  //   })
  // }

  const onShowOut = (e) => {
        e.preventDefault()
      }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    document.querySelectorAll('.attach-file').forEach((a)=>{
      if(a.id == crtSeq){
        a.className = 'attach-file active'
      }else{
        a.className = 'attach-file'
      }
    })
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }
    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        let xhr = new XMLHttpRequest()
        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.send()
        xhr.onload = function () {
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setIsShowPdf(true)
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
      }, 1000)
    })
  }


  return (
    <>
      <h3 className="h3-tit first">문서정보</h3>
      <table className="tbl-view">
        <caption>발급번호, 문서유형, 발급일시, 만료일시, 제출처, 발급기관 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급번호</th>
            <td>{props.data?.docid}</td>
          </tr>
          <tr>
            <th scope="row">문서유형</th>
            <td>{props.commoncode?.CRT_DV?.find((co) => co.cd === props.data?.crtCd)?.cdName}</td>
          </tr>
          <tr>
            <th scope="row">발급일시</th>
            <td>
              {props.data?.issuedt === null || props.data?.issuedt === ''
                ? '-'
                : moment(props.data?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <th scope="row">만료일시</th>
            <td>
              {props.data?.crtfExpryDt === null || props.data?.crtfExpryDt === ''
                ? '-'
                : moment(props.data?.crtfExpryDt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
            </td>
          </tr>
          <tr>
            <th scope="row">제출처</th>
            <td>{props.data?.submission}</td>
          </tr>
          <tr>
            <th scope="row">발급기관</th>
            <td>{props.data?.prchsNm}</td>
          </tr>
        </tbody>
      </table>

      <h3 className="h3-tit first">일반정보</h3>

      <table className="tbl-view">
        <caption>계약명, 계약시작일, 계약종료일, 서명 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">계약명</th>
            <td>{gnrlInfoCn?.ctrtcNm}</td>
          </tr>
          {/*
            <tr>
              <th scope="row">계약금액</th>
              <td>{gnrlInfoCn.ctrtcAmt}</td>
            </tr>
             */}
          <tr>
            <th scope="row">계약시작일</th>
            <td>
              {gnrlInfoCn?.ctrtcBgngYmd === null || gnrlInfoCn?.ctrtcBgngYmd === ''
                ? '-'
                : moment(gnrlInfoCn?.ctrtcBgngYmd, 'YYYYMMDD').format('YYYY.MM.DD')}
            </td>
          </tr>
          <tr>
            <th scope="row">계약종료일</th>
            <td>
              {gnrlInfoCn?.ctrtcEndYMD === null || gnrlInfoCn?.ctrtcEndYMD === ''
                ? '-'
                : moment(gnrlInfoCn?.ctrtcEndYMD, 'YYYYMMDD').format('YYYY.MM.DD')}
            </td>
          </tr>
          <tr>
            <th scope="row">서명</th>
            <td>
              {signerList?.map((signer, index) => (
                <span key={index}>
                  {signer.mbrNm}
                  {signerList?.length - 1 !== index ? '|' : ''}
                </span>
              ))}
            </td>
          </tr>
        </tbody>
      </table>

      <h3 className="h3-tit">발급이력</h3>
      <table className="tbl-view">
        <caption>발급일자 항목으로 구성</caption>
        <colgroup>
          <col className="col1" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th scope="row">발급일자</th>
            <td>{props.data?.issuedt && moment(props.data?.issuedt, 'YYYYMMDDhhmmss').format('YYYY.MM.DD')}</td>
          </tr>
        </tbody>
      </table>
      <div className="btn-block">
        <span className="right">
          {props.data?.fileGroupId !== null && props.data?.fileNewList?.length !== 0 && props.data?.fileNewList?.length === 1 && (
              <span className="attach-wrap">
                {props.data?.fileNewList?.map((fileObj, index) => (
                    <a
                        key={index}
                        href="#"
                        className="btn-primary md"
                        //className="attach attach-link"
                        onClick={(e) => {
                          e.preventDefault()
                          onPdfDown(props.data?.crtCd, props.data?.docid, gnrlInfoCn?.brno, fileObj)
                          return
                        }}
                    >
                      증명서 열람

                    </a>
                ))}
              </span>
          )}
          {props.data?.fileGroupId !== null && props.data?.fileNewList?.length !== 0 && props.data?.fileNewList?.length !== 1 && (
              <span className="attach-wrap">
            <a
                href="#"
                className="btn-secondary md"
                //className="attach attach-link"
                onClick={(e) => {
                  //e.preventDefault()
                  //props.onPDFView()
                  eventHandler(e, props.data?.crtSeq)
                }}
            >
              증명서 열람
            </a>
            <ul
                id={props.data?.crtSeq}
                // className={active === certboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                className='attach-file'
            >
              {props.data?.fileNewList?.map((fileObj, index) => (
                  <li key={index}>
                    <a
                        onClick={(e) => {
                          e.preventDefault()
                          onPdfDown(props.data?.crtCd, props.data?.docid,gnrlInfoCn?.brno,fileObj)
                          onShowOut(e)
                          return
                        }}
                    >
                      {fileObj.originFileNm}
                    </a>
                  </li>
              ))}
            </ul>
          </span>
          )}
          <a
              href="#"
              className="btn-secondary md"
              onClick={(e) => {
                e.preventDefault()
                props.goList()
              }}
          >
            목록
          </a>
        </span>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    commoncode: state.commoncode?.co,
  }
}

const actionCreators = {
  getCommonCode: commonActions.getCommonCode,
  getFile: certboxActions.getFile,
  error: alertActions.error,
  getDownLoad: certboxActions.getDownLoad,
}

export default connect(mapStateToProps, actionCreators)(CertboxForm21)
